// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// require('@/js/analytics.js');
/* global _ */
/* global dataLayer */
import '@utilities/prototypes';
require('@/js/polyfill.js');
import { BDropdown, BDropdownItem, BDropdownDivider, BFormSelect } from 'bootstrap-vue';

import 'animate.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'playposit-analytics';
import PlaypositRubric from '@components/rubric';
import TinyMCE from '@components/tiny-mce';
import PlaypositOffline from '@components/offline';
// import PlayPositWeVideo from '@components/wevideo';
import ChickFilATagButton from '@components/chickfila-tag';
import PlaypositVideoTranscoder from '@components/video-transcoder';
import PlaypositBulbSettings from '@components/bulb-settings';
import PlaypositInteraction from '@components/interaction';
import * as PlaypositUtilities from '@utilities';
import PlaypositErrorScreen from '@components/error-screen';
import Tooltip from '@snippets/vue/Tooltip.vue';
require('../node_modules/vuetify/dist/vuetify.min.css');
require('./css/playposit-videojs-skin.css');
import Vue from 'vue';
import Vuex from 'vuex';
import Vuelidate from 'vuelidate';
import Vuetify from 'vuetify';
import VueResize from 'vue-resize';
import Dash from './Dash';
import ElementUI from 'element-ui-with-a-newer-version-of-lodash';
import 'element-ui-with-a-newer-version-of-lodash/lib/theme-chalk/index.css';
import locale from 'element-ui-with-a-newer-version-of-lodash/lib/locale/lang/en';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import store from './store';
import router from './router';
import './style/style.css';
import _ from 'lodash';
import 'focus-trap';
import VueSweetalert2 from 'vue-sweetalert2';
import VueDOMPurifyHTML from 'vue-dompurify-html'

// attach lodash as a prop to use in vue html rendering
Object.defineProperty(Vue.prototype, '_', { value: _ });

// Setting up our namespaced debugging object:
window.PP = {};

const errFn = console.error;
console.error = err => {
  dataLayer.errorLog(err);
  errFn(err);
}

Vue.use(Vuetify, {
  theme: {
    primary: '#2196F3',
    secondary: '#0d47a1',
    tertiary: '#FFF',
    success: '#1B5E20',
    error: '#AA0000',
    warning: '#FF9800',
    info: '#757575',
  }
});

Vue.config.errorHandler = (...error) => {
  let final = {
    name: error[0].name,
    message: error[0].message,
    location: _.get(error, '[1].$options.__file') || _.get(error, '[1].$options.name'),
    scope: error[2],
  };
  dataLayer.vueLog(final);
}

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(Vuelidate);
Vue.use(Vuetify);
Vue.use(VueSweetalert2);
Vue.use(ElementUI, {locale});
Vue.use(PlaypositOffline);
// Vue.use(PlayPositWeVideo);
Vue.use(ChickFilATagButton);
Vue.use(PlaypositUtilities);
Vue.use(PlaypositErrorScreen);
Vue.use(PlaypositRubric);
Vue.use(TinyMCE);
Vue.use(PlaypositVideoTranscoder);
Vue.use(PlaypositBulbSettings);
Vue.use(PlaypositInteraction);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-item', BDropdownItem);
Vue.component('b-form-select', BFormSelect);
Vue.component('b-dropdown-divider', BDropdownDivider);
Vue.component('Tooltip', Tooltip);
Vue.use(VueResize);
Vue.use(VueDOMPurifyHTML)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<Dash/>',
  store,
  router,
  components: { Dash },
});
